import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (fileId) => `${API}/files/${fileId}`;

export const priceInfo = (p) => {
  const base = p?.base_price || 0;
  const combos = p?.variant_combinations || [];
  if (combos.length) {
    const effs = combos.map((c) => {
      const price = Number(c.price) || 0;
      const promo = Number(c.promo_price) || 0;
      return (promo > 0 && price > 0 && promo < price) ? promo : (price > 0 ? price : base);
    }).filter((n) => n > 0);
    if (effs.length) {
      const min = Math.min(...effs);
      return { base: min, promo: null, effective: min, discount: 0, from: effs.length > 1 };
    }
  }
  const promo = p?.promo_price && p.promo_price > 0 && p.promo_price < base ? p.promo_price : null;
  const effective = promo != null ? promo : base;
  const discount = promo != null ? Math.round((1 - promo / base) * 100) : 0;
  return { base, promo, effective, discount, from: false };
};

export const formatRupiah = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "Rp0";
  return "Rp" + Number(n).toLocaleString("id-ID");
};

